import { useEffect, useState, memo } from 'react';
import KnowledgePointsContent from './knowledge-points-content';
import { getGlobalStore } from '@/store/global';
import { useControlDrawerTransform } from '@/utils/custom-hooks';
import './index.scss';

const KnowledgePointsDrawer = () => {
    const [collectRecordId, setCollectRecordId] = useState<string>();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const { showDrawer, hideDrawer, style } = useControlDrawerTransform({ isFlex: true });

    const handleClose = () => {
        hideDrawer();
        setCollectRecordId(undefined);
        setTimeout(() => setContent(''), 500);
    };

    useEffect(() => {
        getGlobalStore()?.subscribe(
            'KnowledgePointsDrawer',
            (params: { type: string; title: string; content: string; recordId: string }) => {
                switch (params.type) {
                    case 'show':
                        setCollectRecordId(params.recordId);
                        setTitle(params.title);
                        setContent(params.content);
                        showDrawer();
                        break;
                    default:
                        handleClose();
                        break;
                }
            }
        );
    }, []);

    return (
        <div className="knowledge-points-drawer" style={style}>
            <KnowledgePointsContent title={title} content={content} collectRecordId={collectRecordId} onClose={handleClose} />
        </div>
    );
};

export default memo(KnowledgePointsDrawer);
